/*
 * @Author: mayanxia 
 * @Date: 2020-08-28 21:49:25 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-04 13:41:04
 */
 <style scoped lang="less">
 #binsess-center-contain{
   background: url('~@/assets/images/waterQuality-center.png') #071737 no-repeat;
   background-position: center center;
   //background-size: 100% 100%;
   display: flex;
   color: #fff;
 }
</style>
<template>
  <div id="binsess-center-contain" style="height: 100%">
    <div class="flex-center flex" style="">
    </div>
  </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
import { putAction } from '@/api/manage';
import {isNull} from '@/utils/validate'
export default {
  components: {
    animatedInteger
  },
  data() {
    return {
      color: '#5B87C3',
      valueColor: '#00FAFE',
      unitColor: '#6ED9F2',
      url: {
        payMoneyCount: '/jeecg-charge/meter/waterAnalysis/payMoneyCount',
        waterUse: '/jeecg-charge/meter/waterAnalysis/waterUse'
      },
    }
  },
  methods: {
    init() {
      console.log("lalalalla ")
    }
  }
}
</script>
